import { Localization } from "@viamap/viamap2-common";
import { useContext, useState } from "react";
import { ColorBoxEditableV2 } from "src/components/ComponentUtils";
import { GlassButton } from "src/components/GlassButtons";
import { ADModalBody, ADModalFooter, ADModalInfo, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState";
import { setTag, FRPContext, updateProject } from "./FRPState";
import chroma from "chroma-js";
import { MapitUtils } from "src/managers/MapitUtils";
import { MIBIcon } from "src/componentsUtils/MIBIcon";




export function FRPTagEditor(props: {
   managedWindow: ManagedWindow,
   disabled?: boolean,
}) {
   const { dispatch } = useWindowContext();
   const { state: frpState, dispatch: frpDispatch } = useContext(FRPContext);
   const [localTagOptions, setLocalTagOptions] = useState(frpState.tagOptions);



   function confirmChanges() {
      frpDispatch(setTag(localTagOptions));
      dispatch(closeWindow(props.managedWindow.id));
      let loadedProject = frpState.selectedProject;
      if (loadedProject) {
         loadedProject.settings.tagOptions = localTagOptions;
         frpDispatch(updateProject(loadedProject.id, loadedProject));
      }
   }

   function handleDeleteTag(id: string) {
      setLocalTagOptions(prevOptions => prevOptions.filter(tag => tag.id !== id));
   }

   function handleAddTag(item: typeof frpState.tagOptions[number]) {
      const newTag = { ...item, id: MapitUtils.getNewUuid() };
      setLocalTagOptions(prevOptions => [...prevOptions, newTag]);
   }

   function handleUpdateTag(item: typeof frpState.tagOptions[number]) {
      let hueSort = (a, b) => (chroma(a.color).hsl()[0] - chroma(b.color).hsl()[0]);
      setLocalTagOptions(prevOptions => prevOptions.map(el => el.id === item.id ? item : el).toSorted(hueSort));
   }




   return <AdvancedDragModal window={props.managedWindow} title="FRP Tag Editor" onClose={() => { dispatch(closeWindow(props.managedWindow.id)) }}
      PosDefault={{ width: "400px", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }}
   >

      <ADModalInfo center={true}>
         {Localization.getText("tagOptions:info")}.
      </ADModalInfo>
      <ADModalBody>
         <div style={{ display: "flex", flexDirection: "column", paddingLeft: "10px", gap: "2px", marginTop: "10px" }}>
            {localTagOptions?.map((tagOpt, _index) => (
               <div key={tagOpt.id} className="GlassInputControl" style={{ display: "flex", alignItems: "center" }}>
                  <ColorBoxEditableV2
                     color={tagOpt.color}
                     onCommit={(color) => {
                        handleUpdateTag({
                           ...tagOpt,
                           color
                        })
                     }}
                  />
                  <input disabled={props.disabled}
                     value={tagOpt.val}
                     style={{ flex: "auto" }}
                     onChange={(e) => {
                        const newStatus = e.target.value;

                        handleUpdateTag({
                           ...tagOpt,
                           val: newStatus
                        })
                     }} />
                  <div style={{ width: "4px", height: "2px" }} />
                  {!props.disabled ? <div title={Localization.getText("Delete")} style={{ cursor: "pointer", display: "flex", alignItems: "center" }} onClick={() => {
                     handleDeleteTag(tagOpt.id);
                  }}>
                     <MIBIcon icon="Remove" />
                  </div> : <></>}

               </div>
            ))}
            <div style={{ padding: "2px" }}>
               <GlassButton onClick={() => { handleAddTag({ id: MapitUtils.getNewUuid(), val: "New Tag", color: "#000000" }) }}>{Localization.getText("Add")}</GlassButton>
            </div>
         </div>
      </ADModalBody>
      <ADModalFooter>
         {/* <GlassButtonRow> */}
         <GlassButton onClick={() => { dispatch(closeWindow(props.managedWindow.id)) }}>{Localization.getText("Cancel")}</GlassButton>
         <GlassButton disabled={props.disabled} onClick={confirmChanges}>{Localization.getText("Save")}</GlassButton>
         {/* </GlassButtonRow> */}
      </ADModalFooter>
   </AdvancedDragModal>
}